export default __webpack_public_path__ + "static/media/ncashUtilityLarge.83fca53e.png";